<template>
  <input
      :value="value"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
      v-bind="{...$props, ...inputAttributes}"
  />
</template>

<script>
import { isDefined } from '@/utilities';

export default {
  props: {
    modelValue: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String
    },
    value: {}
  },
  computed: {
    inputAttributes() {
      return {...this.$attrs, ...{class: isDefined(this.$attrs.class) ? this.$attrs.class : ''}}
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onChange(event) {
      this.$emit('change', event.target.value);
    },
    onBlur(event) {
      this.$emit('blur', event);
    }
  }
}
</script>
